import { clsx } from 'clsx'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Typography } from '@/src/elements/text/Typography'

import type { TChatMessageProps } from '../ChatMessage.types'
import { ChatMessageBubble } from '../ChatMessageBubble'
import { ChatMessageThumbnail, type TChatMessageThumbnailProps } from '../ChatMessageThumbnail'
import { ChatMessageTimestamp } from '../ChatMessageTimestamp'
import { type TChatMessageAutoType, chatMessageAutoData } from './chatMessageAutoData'

type TChatMessageAutoProps = Pick<
  TChatMessageProps,
  'contactName' | 'createdAt' | 'firstOfBatch' | 'isSender' | 'lastOfBatch'
> & {
  type: TChatMessageAutoType
  thumbnail?: Omit<TChatMessageThumbnailProps, 'color'>
}

export const ChatMessageAuto = ({
  contactName,
  createdAt,
  firstOfBatch,
  isSender,
  lastOfBatch,
  thumbnail,
  type,
}: TChatMessageAutoProps) => {
  const { title, comment, emoji } = chatMessageAutoData[type]

  return (
    <ChatMessageBubble
      firstOfBatch={firstOfBatch}
      isSender={isSender}
      lastOfBatch={lastOfBatch}
      className={clsx(
        'border-1 border-solid p-2 gap-2 max-w-full',
        isSender ? 'bg-secondary-bg-light border-blue-300' : 'bg-white border-amber-300',
      )}
    >
      {thumbnail && <ChatMessageThumbnail color={isSender ? 'default' : 'secondary'} {...thumbnail} />}
      <View className="gap-2 px-2">
        <View className="flex flex-row items-center gap-2">
          <Typography size="2xl" colors={isSender ? 'secondary' : 'default'}>
            {emoji}
          </Typography>
          <Typography bold size="lg" contrast="low" colors={isSender ? 'secondary' : 'primary'}>
            <FormattedMessage id={title[isSender ? 'fromMe' : 'toMe']} values={{ contactName }} />
          </Typography>
        </View>
        {comment && (
          <Typography
            contrast={isSender ? 'high' : 'default'}
            colors={isSender ? 'secondary' : 'default'}
            className="max-w-full"
          >
            <FormattedMessage id={comment[isSender ? 'fromMe' : 'toMe']} values={{ contactName }} />
          </Typography>
        )}
        {lastOfBatch && <ChatMessageTimestamp color="default" createdAt={createdAt} />}
      </View>
    </ChatMessageBubble>
  )
}
